import React from "react";
import "./About.css";
import { Type } from "./Type";
import GitHubIcon from "@material-ui/icons/GitHub";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import EmailIcon from "@material-ui/icons/Email";
import PhoneIcon from "@material-ui/icons/Phone";
import TwitterIcon from "@material-ui/icons/Twitter";
// import XIcon from '@mui/icons-material/X';
import DescriptionIcon from "@material-ui/icons/Description";
// import PublicIcon from "@material-ui/icons/Public";
import { Introduction } from "./Introduction";
import { Timeline } from "./Timeline";
import { Techstacks } from "./Techstacks";
import CertificateSlides  from "../CertificateSlides/CertificateSlides";
import { BiArrowFromTop } from "react-icons/bi";
// import Button from "@mui/material/Button";
export const About = () => {
  return (
    <>
      <div className="about center">
        <h1 data-aos="fade-right" className="mobileHead">
          Hello, I am <span className="about__name">Suvranil Ghose</span>
        </h1>
        <Type />
        <p className="about__desc" data-aos="fade-right">
        Passionate and creative Full Stack Developer having proficiency in
          MERN Stack. Attired with a variety of tools & technologies and keen to
          learn new one. Worked on personal projects since last 3 months and developed
          5+ projects at par with industry standards.
        </p>
        <div className="about__contact center">
          <a
            href="https://github.com/SuvranilG"
            aria-label="github"
            target="_blank"
            rel="noreferrer"
            className="link link--icon"
          >
            <GitHubIcon />
          </a>
          <a
            href="mailto:technicalsuvranil@gmail.com"
            target="_blank"
            rel="noreferrer"
            aria-label="mail"
            className="link link--icon"
          >
            <EmailIcon />
          </a>
          <a
            href="tel:+918658249899"
            target="_blank"
            rel="noreferrer"
            aria-label="phone"
            className="link link--icon"
          >
            <PhoneIcon />
          </a>
          <a
            href="https://www.linkedin.com/in/suvranilghose/"
            aria-label="linkedin"
            className="link link--icon"
            target="_blank"
            rel="noreferrer"
          >
            <LinkedInIcon />
          </a>
          {/* <a
            href="https://twitter.com/"
            aria-label="twitter"
            className="link link--icon"
            target="_blank"
            rel="noreferrer"
          >
            <TwitterIcon />
            <XIcon />
          </a> */}
        </div>

        <button
          className="btnResume"
          onClick={() => {
            const link=process.env.REACT_APP_ResumeLink;
            window.open(
              link
            );
          }}
        >
          Resume 
        </button>
      </div>
      <Introduction />
      <Timeline />
      <section id="#certificates">
      <CertificateSlides />
      </section>
      <section id="#skills">
        <Techstacks />
      </section>
    </>
  );
};
